export const SLOT_TYPES = {
  HP: 'hp',
  STRESS: 'stress',
  ARMOR: 'armor',
  HOPE: 'hope',
  FOCUS: 'focus',
} as const;

export const SLOT_ICONS = {
  [SLOT_TYPES.HP]: '♥',
  [SLOT_TYPES.STRESS]: '⚡',
  [SLOT_TYPES.ARMOR]: '🛡',
  [SLOT_TYPES.HOPE]: '★',
  [SLOT_TYPES.FOCUS]: '🔮',
} as const;

export const BUTTON_VARIANTS = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  TERTIARY: 'tertiary',
  CLEAR: 'clear',
  COUNTER: 'counter',
} as const;

export const BUTTON_SIZES = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
} as const;

export const INPUT_TYPES = {
  TEXT: 'text',
  NUMBER: 'number',
  SIGNED_NUMBER: 'signed_number',
} as const;

export const ROUTES = {
  CHARACTER_SELECT: '/',
  CHARACTER_SHEET: '/character',
  COMBAT_TRACKER: '/combat',
  CONTENT_LIBRARY: '/library',
  DEVELOPER: '/dev',
  BIOGRAPHY: '/biography',
  LEGAL: '/legal',
} as const;

export const AUTO_SAVE_DELAY = 60000; // 60 seconds

export const BREAKPOINTS = {
  MOBILE: 640,
  TABLET: 768,
  DESKTOP: 1024,
} as const;